import styled from 'styled-components'
import { mobileFirstMedia as media } from 'utils/media'

export const CategoryContainer = styled.section`
  position: relative;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
`

export const CategoryTitle = styled.h3`
  background-color: #fff;
  font-family: 'Montserrat', sans-serif !important;
  font-size: 18px;
  font-weight: 700;
  padding: 30px 15px 30px;

  ${media.screen`
    background-color: none;
    font-size: 20px;
    font-weight: 500;  
  `}
`

export const MenuListContainer = styled.ul`
  background-color: ${props => props.theme.colors.white};
  margin-bottom: 32px;
`
